var _circle, _circle2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoodLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0658,
    cy: 17.0658,
    r: 6.62436,
    stroke: "#011133",
    strokeWidth: 1.25
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.7109,
    y: 6,
    width: 1.34673,
    height: 3.36681,
    rx: 0.673363,
    transform: "rotate(19.2106 20.7109 6)",
    fill: "#011133"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.252,
    y: 24.1797,
    width: 1.34673,
    height: 3.36681,
    rx: 0.673363,
    transform: "rotate(20.7117 13.252 24.1797)",
    fill: "#011133"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9199,
    y: 6.58594,
    width: 1.34673,
    height: 3.36681,
    rx: 0.673363,
    transform: "rotate(-25.7894 11.9199 6.58594)",
    fill: "#011133"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5039,
    y: 24.7109,
    width: 1.34673,
    height: 3.36681,
    rx: 0.673363,
    transform: "rotate(-24.2883 19.5039 24.7109)",
    fill: "#011133"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 13.332,
    width: 1.34673,
    height: 3.36681,
    rx: 0.673363,
    transform: "rotate(-70.7894 6 13.332)",
    fill: "#011133"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1797,
    y: 21.4023,
    width: 1.34673,
    height: 3.36681,
    rx: 0.673363,
    transform: "rotate(-69.2883 24.1797 21.4023)",
    fill: "#011133"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.58984,
    y: 22.8203,
    width: 1.34673,
    height: 3.36681,
    rx: 0.673363,
    transform: "rotate(-115.789 6.58984 22.8203)",
    fill: "#011133"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 24.9297,
    y: 15.0586,
    width: 1.34673,
    height: 3.36681,
    rx: 0.673363,
    transform: "rotate(-114.288 24.9297 15.0586)",
    fill: "#011133"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5425 17.7195C13.519 17.7429 13.5059 17.7747 13.5059 17.8078C13.5059 17.841 13.519 17.8728 13.5425 17.8962L16.0607 20.4144C16.1095 20.4632 16.1886 20.4633 16.2374 20.4145L16.2379 20.4139L16.238 20.4139L16.9568 19.6951L16.9568 19.6951L21.2733 15.378C21.3221 15.3292 21.3221 15.2501 21.2733 15.2013L20.554 14.4819C20.5305 14.4585 20.4988 14.4453 20.4656 14.4453C20.4325 14.4453 20.4007 14.4585 20.3772 14.4819L16.1498 18.7094L14.4385 17.0001C14.3897 16.9513 14.3106 16.9513 14.2618 17.0001L13.5425 17.7195Z",
    fill: "#011133",
    stroke: "#011133",
    strokeWidth: 0.25,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodLight);
export default __webpack_public_path__ + "static/media/Good-light.0c3277bb3c633636fb8c9bb498b96ada.svg";
export { ForwardRef as ReactComponent };